import { render, staticRenderFns } from "./ProgrammingHistoryStatsDialog.vue?vue&type=template&id=5ad55011&scoped=true&"
import script from "./ProgrammingHistoryStatsDialog.vue?vue&type=script&lang=js&"
export * from "./ProgrammingHistoryStatsDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProgrammingHistoryStatsDialog.vue?vue&type=style&index=0&id=5ad55011&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad55011",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VContainer,VDialog,VDivider,VIcon,VRow})
